import React from "react";
import { Link } from "react-router-dom";
import { useSiteSettings } from "../../contexts/SiteSettingsContext";

const SIZE_CLASSES = {
  sm: { box: "h-8 w-8 rounded-lg text-sm", text: "text-base", gap: "gap-2" },
  md: { box: "h-10 w-10 rounded-xl text-lg", text: "text-lg", gap: "gap-2.5" },
  lg: { box: "h-12 w-12 rounded-xl text-xl", text: "text-2xl", gap: "gap-3" },
  xl: { box: "h-14 w-14 rounded-2xl text-2xl", text: "text-3xl", gap: "gap-3" },
};

/**
 * Platform logo + name. Uses superadmin branding when configured; falls back to emoji + default name.
 */
export default function SiteBrandMark({
  size = "md",
  showName = true,
  nameOverride,
  logoUrlOverride,
  tagline,
  className = "",
  nameClassName = "",
  taglineClassName = "hidden sm:block text-xs text-slate-500 font-medium",
  linkTo,
  onClick,
}) {
  const { siteName, siteLogoUrl } = useSiteSettings();
  const displayName = nameOverride || siteName;
  const logoUrl = logoUrlOverride !== undefined ? logoUrlOverride : siteLogoUrl;
  const sizes = SIZE_CLASSES[size] || SIZE_CLASSES.md;

  const mark = logoUrl ? (
    <img
      src={logoUrl}
      alt=""
      className={`${sizes.box} shrink-0 object-contain bg-white`}
    />
  ) : (
    <span
      className={`flex ${sizes.box} shrink-0 items-center justify-center bg-brand/10`}
      aria-hidden
    >
      🍽️
    </span>
  );

  const content = (
    <>
      {mark}
      {showName && (
        <span className={`min-w-0 truncate ${tagline ? "flex flex-col" : ""}`}>
          <span className={`font-bold text-slate-900 leading-tight truncate ${sizes.text} ${nameClassName}`}>
            {displayName}
          </span>
          {tagline ? <span className={taglineClassName}>{tagline}</span> : null}
        </span>
      )}
    </>
  );

  const wrapperClass = `flex items-center min-w-0 no-underline text-inherit ${sizes.gap} ${className}`;

  if (linkTo) {
    return (
      <Link to={linkTo} className={wrapperClass} onClick={onClick}>
        {content}
      </Link>
    );
  }

  if (onClick) {
    return (
      <button type="button" className={`${wrapperClass} bg-transparent border-0 p-0 cursor-pointer`} onClick={onClick}>
        {content}
      </button>
    );
  }

  return <div className={wrapperClass}>{content}</div>;
}
